import { Route, Routes, Navigate } from 'react-router-dom';
import NDAPage from '../Views/NDA';
import NoProjectsPage from '../Views/NoProjects';
import OverviewPage from '../Views/Overview';
import Team from '../Views/Team';
import Messages from '../Views/Messages';
import LoginPage from '../Views/Login';
import RegisterPage from '../Views/Register';
import UploadNdaPage from '../Views/UploadNda';
import NDASuccessPage from '../Views/NDASuccess';
import ProtectedRoute from '../utils/ProtectedRoutes';
import FeatureProtectedRoute from '../utils/FeatureProtectedRoute';
import DataroomPage from '../Views/Dataroom';
import ForgotPasswordView from '../Views/ForgotPassword';
import ConfirmMailView from '../Views/ConfirmMail';
import ResetPasswordView from '../Views/ResetPassword';
import ObservationsView from '../Views/Observations';
import Projects from '../Views/Projects';
import SecureAccountView from '../Views/SecureAccount';
import AuthenticateView from '../Views/Authenticate';
import IRLView from '../Views/IRL';
import TasksInterfaceView from '../Views/TasksInterface';
import RaidView from '../Views/Raid';
import LessonsView from '../Views/Lessons';
import ActionLogView from '../Views/ActionLog';
import RequestInviteView from '../Views/RequestInvite';
import PermissionsView from '../Views/Permissions';
import ProjectDetailspage from '../Views/ProjectDetails';
import CreateNewProjectPage from '../Views/CreateNewProject';
import SwotAnalysisView from '../Views/SwotAnalysis';
import QuestionBankView from '../Views/QuestionBank';
import React from 'react';
import WizardPage from '../Views/Wizard';
import MaturityIndexPage from '../Views/MaturityIndex';
import SecurityIndexPage from '../Views/SecurityIndex';
import TeamAnalyserPage from '../Views/TeamAnalyser';
import SecurityGovernancePage from '../Views/SecurityGovernance';
import EditProjectPage from '../Views/EditProject';
import SoftwareInventoryPage from '../Views/SoftwareInventory';
import UserSettings from '../Views/UserSettings';
import CompleteProfile from '../Views/CompleteProfile';
import Setup2FAPage from '../Views/Setup2FAPage';
import Journal from '../Views/Journal';
import JournalAnalysisView from '../Views/JournalAnalysis';
import Tent from '../Views/Tent';
import LensIntelligenceView from '../Views/LensIntelligence';
import LensIntelligenceInsightsView from '../Views/LensIntelligenceInsights';
import LensIntelligenceDebugView from '../Views/LensIntelligenceDebug';
import SelectWorkspacePage from '../Views/SelectWorkspace';
import NoWorkspaceAccessPage from '../Views/NoWorkspaceAccess';
import WorkspaceSettingsPage from '../Views/WorkspaceSettings';
import WorkspacePulseView from '../Views/WorkspacePulse';
import WorkspaceSetupPage from '../Views/WorkspaceSetupPage';
import WorkspaceSetupGuard from '../utils/WorkspaceSetupGuard';
import SharedDocumentPage from '../Views/SharedDocumentPage';
import ValidateInvitePage from '../Views/ValidateInvitePage';
import PulseDeepLinkRedirect from '../Views/PulseDeepLinkRedirect';

const Routers = () => {
    return (
        <Routes>
            <Route exact path="/" element={<LoginPage />} />
            <Route path="/validate-invite/:key" element={<ValidateInvitePage />} />
            <Route path="/register/:key/:project?" element={<RegisterPage />} />
            <Route exact path="/complete-profile" element={<CompleteProfile />} />
            <Route exact path="/forgot-password" element={<ForgotPasswordView />} />
            <Route exact path="/confirm-mail" element={<ConfirmMailView />} />
            <Route exact path="/secure" element={<SecureAccountView />} />
            <Route exact path="/authenticate" element={<AuthenticateView />} />
            <Route exact path="/setup-2fa" element={<Setup2FAPage />} />
            <Route exact path="/request-invite" element={<RequestInviteView />} />
            <Route exact path="/reset-password/:uid/:token" element={<ResetPasswordView />} />
            <Route element={<ProtectedRoute allowedRoles={['Investor', 'Management']} />}>{/* <Route path="/overview" element={<OverviewPage />} /> */}</Route>
            <Route element={<ProtectedRoute allowedRoles={['Consultant']} />}>{/* <Route path="/observations" element={<ObservationsView />} /> */}</Route>
            <Route element={<ProtectedRoute allowedRoles={['Investor', 'Consultant']} />}>
                <Route path="/noprojects" element={<NoProjectsPage />} />
                <Route path="/NDASuccess" element={<NDASuccessPage />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={['Investor', 'Management', 'Consultant', '']} />}>
                <Route path="/select-workspace" element={<SelectWorkspacePage />} />
                <Route path="/no-workspace-access" element={<NoWorkspaceAccessPage />} />
                <Route
                    path="/overview"
                    element={
                        <FeatureProtectedRoute featureKey="project_overview">
                            <OverviewPage />
                        </FeatureProtectedRoute>
                    }
                />
                <Route path="/project" element={<Projects />} />
                <Route
                    path="/irl"
                    element={
                        <FeatureProtectedRoute featureKey="information_requests">
                            <IRLView />
                        </FeatureProtectedRoute>
                    }
                />
                <Route
                    path="/observations"
                    element={
                        <FeatureProtectedRoute featureKey="observations">
                            <ObservationsView />
                        </FeatureProtectedRoute>
                    }
                />
                <Route
                    path="/lens-intelligence"
                    element={
                        <FeatureProtectedRoute featureKey="lens_intelligence">
                            <LensIntelligenceView />
                        </FeatureProtectedRoute>
                    }
                />
                <Route
                    path="/lens-intelligence/insights"
                    element={
                        <FeatureProtectedRoute featureKey="lens_intelligence">
                            <LensIntelligenceInsightsView />
                        </FeatureProtectedRoute>
                    }
                />
                <Route
                    path="/lens-intelligence/debug"
                    element={
                        <FeatureProtectedRoute featureKey="lens_intelligence">
                            <LensIntelligenceDebugView />
                        </FeatureProtectedRoute>
                    }
                />
                <Route path="/swot" element={<SwotAnalysisView />} />
                <Route path="/question-bank" element={<QuestionBankView />} />
                <Route
                    path="/dataroom"
                    element={
                        <FeatureProtectedRoute featureKey="dataroom">
                            <DataroomPage />
                        </FeatureProtectedRoute>
                    }
                />
                <Route
                    path="/shared/document/:shareId"
                    element={
                        <FeatureProtectedRoute featureKey="dataroom">
                            <SharedDocumentPage />
                        </FeatureProtectedRoute>
                    }
                />
                <Route
                    path="/wizard"
                    element={
                        <FeatureProtectedRoute featureKey="dataroom_wizard">
                            <WizardPage />
                        </FeatureProtectedRoute>
                    }
                />
                <Route
                    path="/security-governance"
                    element={
                        <FeatureProtectedRoute featureKey="security_governance">
                            <SecurityGovernancePage />
                        </FeatureProtectedRoute>
                    }
                />
                <Route
                    path="/maturity-index"
                    element={
                        <FeatureProtectedRoute featureKey="maturity_index">
                            <MaturityIndexPage />
                        </FeatureProtectedRoute>
                    }
                />
                <Route
                    path="/security-index"
                    element={
                        <FeatureProtectedRoute featureKey="security_index">
                            <SecurityIndexPage />
                        </FeatureProtectedRoute>
                    }
                />
                <Route
                    path="/team-analyser"
                    element={
                        <FeatureProtectedRoute featureKey="team_analyser">
                            <TeamAnalyserPage />
                        </FeatureProtectedRoute>
                    }
                />
                <Route path="/messages" element={<Messages />} />
                <Route path="/uploadnda" element={<UploadNdaPage />} />
                <Route path="/AddProjectDetails" element={<ProjectDetailspage />} />
                <Route path="/create-project" element={<CreateNewProjectPage />} />
                <Route path="/EditProject" element={<EditProjectPage />} />
                <Route path="/nda" element={<NDAPage />} />
                <Route
                    path="/tasks"
                    element={
                        <FeatureProtectedRoute featureKey="project_management">
                            <TasksInterfaceView />
                        </FeatureProtectedRoute>
                    }
                />
                <Route
                    path="/raid"
                    element={
                        <FeatureProtectedRoute featureKey="raid_log">
                            <RaidView />
                        </FeatureProtectedRoute>
                    }
                />
                <Route
                    path="/lessons"
                    element={
                        <FeatureProtectedRoute featureKey="lessons_learnt">
                            <LessonsView />
                        </FeatureProtectedRoute>
                    }
                />
                <Route
                    path="/action-log"
                    element={
                        <FeatureProtectedRoute featureKey="action_log">
                            <ActionLogView />
                        </FeatureProtectedRoute>
                    }
                />
                <Route path="/team/:type" element={<Team />} />
                <Route
                    path="/software-inventory"
                    element={
                        <FeatureProtectedRoute featureKey="software_inventory">
                            <SoftwareInventoryPage />
                        </FeatureProtectedRoute>
                    }
                />
                <Route path="/user-settings" element={<UserSettings />} />
                <Route
                    path="/settings/notifications"
                    element={<Navigate to="/user-settings?section=email-preferences" replace />}
                />
                <Route
                    path="/projects/:projectId/tasks/:taskId"
                    element={
                        <PulseDeepLinkRedirect target="tasks" />
                    }
                />
                <Route path="/projects/:projectId/dataroom/irl/:irlId" element={<PulseDeepLinkRedirect target="irl" />} />
                <Route path="/projects/:projectId/dataroom/irl" element={<PulseDeepLinkRedirect target="irl" />} />
                <Route path="/projects/:projectId/dataroom" element={<PulseDeepLinkRedirect target="dataroom" />} />
                <Route path="/projects/:projectId/raid" element={<PulseDeepLinkRedirect target="raid" />} />
                <Route path="/projects/:projectId/observations" element={<PulseDeepLinkRedirect target="observations" />} />
                <Route path="/projects/:projectId/action-log" element={<PulseDeepLinkRedirect target="action-log" />} />
                <Route path="/projects/:projectId" element={<PulseDeepLinkRedirect target="overview" />} />
                <Route
                    path="/workspace-setup/:workspaceId"
                    element={
                        <WorkspaceSetupGuard>
                            <WorkspaceSetupPage />
                        </WorkspaceSetupGuard>
                    }
                />
                <Route path="/workspace-settings/:workspaceId" element={<WorkspaceSettingsPage />} />
                <Route path="/workspace-pulse" element={<WorkspacePulseView />} />
                <Route
                    path="/journal"
                    element={
                        <FeatureProtectedRoute featureKey="journal">
                            <Journal />
                        </FeatureProtectedRoute>
                    }
                />
                <Route
                    path="/journal/analysis"
                    element={
                        <FeatureProtectedRoute featureKey="journal">
                            <JournalAnalysisView />
                        </FeatureProtectedRoute>
                    }
                />
                <Route
                    path="/tent"
                    element={
                        <FeatureProtectedRoute featureKey="the_tent">
                            <Tent />
                        </FeatureProtectedRoute>
                    }
                />
                {/* <Route path="/tc" element={<TermsConditionsView />} /> */}
                <Route path="/permissions/:type/:id" element={<PermissionsView />} />
            </Route>
            {/* Catch-all for /login and any other unmatched path — must be last so /shared/document/:id is matched by the protected route above */}
            <Route path="/*" element={<LoginPage />} />
        </Routes>
    );
};

export default Routers;
